import { render, staticRenderFns } from "./EvidencePage.vue?vue&type=template&id=1abab6be&scoped=true&"
import script from "./EvidencePage.vue?vue&type=script&lang=js&"
export * from "./EvidencePage.vue?vue&type=script&lang=js&"
import style0 from "./EvidencePage.vue?vue&type=style&index=0&id=1abab6be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abab6be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VContainer,VLayout,VMain,VRow,VSheet})
